import { SIDE_PANEL_COLLAPSED_WIDTH, SIDE_PANEL_EXPANDED_WIDTH, SIDE_PANEL_WIDTH } from 'automation-ui-core/constants/ui';
import { DataPanelVisibleStates } from 'automation-ui-formula-editor/data-passing-panel/DataPassingContext';
export function getSidebarWidthForDataPanelState(state) {
  if (state === DataPanelVisibleStates.OPEN) {
    return SIDE_PANEL_EXPANDED_WIDTH;
  } else if (state === DataPanelVisibleStates.COLLAPSED) {
    return SIDE_PANEL_COLLAPSED_WIDTH;
  } else {
    return SIDE_PANEL_WIDTH;
  }
}